export default __webpack_public_path__ + "static/media/portrait3.89b3978a.jpeg";